import { FC, useEffect, useState } from 'react'
import cn from './index.module.css'
import SliderNewDesign from '@pages/Courses/all/SliderNewDesign'
import { fetchCourseBanners } from './api'

interface ICoursesBanner {}

const CoursesBanner: FC<ICoursesBanner> = ({}) => {
  const [banners, setBanners] = useState<ICoursesBanner[]>([])

  useEffect(() => {
    async function fetch() {
      let banners = await fetchCourseBanners()
      setBanners(banners)
    }

    fetch()
  }, [])

  return (
    <div className={cn.wrapper}>
      {/* @ts-ignore */}
      <SliderNewDesign slides={banners} />
    </div>
  )
}

export default CoursesBanner
